export const NAMESPACE = 'delivery';
